export default __webpack_public_path__ + "static/cert-2-3667b53bd2dede8e194e60fdb2959bef.png";